import _               from 'underscore';
import { omitDeep }    from '../util';
import { KeyedObject } from '../types';

export function asType( type: string, atts = {} ){
	return {
		__typename: type,
		...atts
	}
}

export function withoutType( objWithType: KeyedObject ){
	
	return omitDeep( objWithType, "__typename" );
}

export function isResolver( typename: 'Query' | 'Mutation' | string ): Function{
	
	return function( target: any ){
		target.descriptor.isResolver   = true;
		target.descriptor.resolverType = typename;
	}
}

export function withResolvers( target: any ){
	
	let resolvers: KeyedObject = _.compact( target.elements.map( ( element: any ) => {
		
		if( element.descriptor.isResolver ){
			return {
				typename: element.descriptor.resolverType,
				key:      element.key,
				method:   element.descriptor.value
			}
		}
		return null;
	} ) );
	
	resolvers = _.groupBy( resolvers, 'typename' );
	resolvers = _.mapObject( resolvers, methods => _.indexBy( methods, 'key' ) );
	resolvers = _.mapObject( resolvers, methods => _.mapObject( methods, resolverFunc => resolverFunc.method ) );
	
	target.elements.push( {
		kind:        "field",
		key:         "resolvers",
		placement:   "static",
		descriptor:  { configurable: true, writable: true, enumerable: true },
		initializer: () => resolvers
	} );
	
	return target;
}

export function queriesLoading( queries: any | any[] ): boolean{
	
	if( !_.isArray( queries ) ){
		
		return queries.loading;
		
	} else {
		
		return _.isArray( queries ) && _.some( queries, q => q.loading );
	}
}

export function queriesHaveErrors( queries: any | any[] ): boolean{
	
	if( !_.isArray( queries ) ){
		
		return !_.isUndefined( queries.error );
		
	} else {
		
		return _.isArray( queries ) && _.some( queries, ( q: any ) => q.error );
	}
}

export function queriesHaveData( queries: any | any[], inclusive = true ): boolean{
	
	let hasMultiple = _.isArray( queries );
	
	if( !hasMultiple ){
		
		return !_.isUndefined( queries.data );
		
	} else if( hasMultiple && _.some( queries, q => q.data ) ){
		
		let requestsWithData = _.filter( queries.map( ( q: any ) => q.data ) );
		
		return inclusive
		       ? ( requestsWithData.length === queries.length )
		       : ( requestsWithData.length !== 0 );
		
	}
	
	return false;
}
